/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/formDefaults.ts (Dynamic Destinations)
 🗓️ Created: 2025-01-27
 🧩 Description:
    Default values and factories for Dynamic Destinations forms.
────────────────────────────────────────────────────────────────*/

import { FormState, DynamicDestinationOptionFormData } from '../types';

/**
 * Create empty option
 */
export function createEmptyOption(priority: number): DynamicDestinationOptionFormData {
  return {
    matchValue: '',
    destinationModule: '',
    destinationValue: '',
    enabled: true,
    priority,
  };
}

/**
 * Default form state
 */
export const DEFAULT_FORM_STATE: FormState = {
  name: '',
  sourceType: 'DB',
  sourceConfig: '',
  queryTemplate: '',
  matchField: '',
  defaultModule: '',
  defaultDestination: '',
  description: '',
  active: true,
  options: [createEmptyOption(1)],
};

/**
 * Get default form state
 */
export function getDefaultFormState(): FormState {
  return JSON.parse(JSON.stringify(DEFAULT_FORM_STATE));
}

/**
 * Deep clone utility
 */
export function deepClone<T>(value: T): T {
  return typeof structuredClone === 'function'
    ? structuredClone(value)
    : JSON.parse(JSON.stringify(value));
}

